export const palette = {
  cocoaBrown: '#2f1f19',
  heatheredGrey: '#98918a',
  white: '#fff'
};
